import './Dashboard.css';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import apiinfo from '../../utils/base-uri.json';
import axios from "../../utils/fvAxios";
import { useEffect, useState } from "react";
function DashboardAnalytics() {

  const [details, setDetails] = useState([]);
  const [token, setToken] = useState("");
  
  useEffect(() => {
    axios.get(apiinfo.Metrics.DashboardMetrics,
    ).then(res => {
      setDetails(res.data.data.embedReports)
      setToken(res.data.data.embedToken.token)
    }).catch(err => {
      console.log(err)
    })
  }, []);

  return (
    <>
      <h2 style={{float:"left",marginBottom:"20px"}}>Dashboard Analytics</h2>

      {details.map((r, index) =>
        <PowerBIEmbed
        style={{marginTop:"none",height:"100%"}}
          key={index}
          embedConfig={{
            type: 'report',
            id: r.reportId,
            embedUrl: r.embedUrl,
            accessToken: token,
            tokenType: models.TokenType.Embed,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: true
                },
                bars: {
                  statusBar: {
                      visible: false
                  }
              }
        
              },
            }
          }}

          eventHandlers={
            new Map([
              ['loaded', function () { console.log('Report loaded'); }],
              ['rendered', function () { console.log('Report rendered'); }],
              ['error', function (event) { console.log(event.detail); }]
            ])
          }

          cssClassName={"embed_container"}
          

          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      )}
    </>
  );
}

export default DashboardAnalytics;